export default __webpack_public_path__ + "static/media/doc2.eb28ed27.svg";